
(function (jQuery, undefined) {

    jQuery.widget("ui.combobox", {
        version: "1.9.2",
        defaultElement: "<div>",
        options: {},

        // widget constructor method
        _create: function () {

            // scoped variable to this
            var _this = this;

            // grab attributes and controls from the element
            this.searchUrl = this.element.attr('data-combobox-search');
            this.baseUrl = this.element.attr('data-combobox-base-uri');
            this.slideupUrl = this.element.attr('data-slideup-search');
            this.infoUrl = this.element.attr('data-info-url');
            this.searchTitle = this.element.attr('data-search-title');
            this.textbox = this.element.find('input[type=text]');
            this.hidden = this.element.find('input[type=hidden]');
            this.statusIcon = this.element.find('.icon').first();
            this.searchIcon = this.element.find('.icon').last();
            this.searchIndex = 0;
            this.startValue = null;
            this.defaultInfoHtml = '<div class="paneContent"></div>';
            this.loadFlyout = true;

            // create or reuse the page results div
            this.resultsDiv = jQuery('#comboboxResults');
            if (this.resultsDiv.length == 0) {
                this.resultsDiv = jQuery('<div id="comboboxResults" class="comboSearchResults"></div>').appendTo('body').hide();
            }

            // create or reuse the flyout div
            var flyoutDivID = _this.textbox.attr("id") + "comboboxResultFlyout";
            this.flyoutDiv = jQuery('#' + flyoutDivID);
            if (this.flyoutDiv.length == 0) {
                this.flyoutDiv = jQuery('<div id="' + flyoutDivID + '" class="att" data-simple-replace="true" data-remove-padding="true">' + this.defaultInfoHtml + '</div>').appendTo('body');
            }

            // wire up the focus event
            this.textbox.on('focus', function (event) {
                var jQuerythis = jQuery(this);

                // on focus, make sure the results div is in the correct location
                _this._positionResults();

                // by default, load the results immediately
                _this._loadResults();

                // store the initial value from the textbox
                _this.startValue = _this.textbox.val();

                // select all text in textbox on focus - fire outside of scope so that the event isn't overridden
                self.setTimeout("jQuery('#" + _this.textbox.attr("id") + "').select();", 0);

                // don't let the event bubble up
                event.preventDefault();

                // reset back to valid on focus
                //trs.ui.makeElementValid(jQuerythis);
            });

            // wire up the keyup event
            this.textbox.on('keyup', function (event) {
                var keyCode = jQuery.ui.keyCode;

                // test the key code
                switch (event.keyCode) {
                    case keyCode.UP:
                    case keyCode.DOWN:
                    case keyCode.LEFT:
                    case keyCode.RIGHT:
                    case keyCode.TAB:
                    case keyCode.ENTER:
                    case keyCode.NUMPAD_ENTER:
                        // do nothing
                        break;
                    default:
                        // load new results div
                        _this._loadResults();
                        break;
                }
            });

            // wire up the keydown event
            this.textbox.on('keydown', function (event) {
                var keyCode = jQuery.ui.keyCode;

                // test the key code
                switch (event.keyCode) {
                    case keyCode.UP:
                        // navigate results list up
                        _this._navigateResults(-1);
                        event.preventDefault();
                        break;
                    case keyCode.DOWN:
                        // navigate results list down
                        _this._navigateResults(1);
                        event.preventDefault();
                        break;
                    case keyCode.LEFT:
                    case keyCode.RIGHT:
                    case keyCode.TAB:
                        // do nothing
                        break;
                    case keyCode.ENTER:
                    case keyCode.NUMPAD_ENTER:
                        // select the value
                        _this._selectResult();
                        event.preventDefault();
                        break;
                }
            });

            // wire up blur event
            this.textbox.on('blur', function (e, v) {
                _this._hideResults();
                // Remove the spinner from this textbox
                jQuery(_this.textbox).removeClass('comboLoading');
            });

            // setup flyout
            var comboboxHasValue = parseInt(this.hidden.val()) > 0;
        },

        // get ajax results from server
        _loadResults: function () {

            // scoped variable to this
            var _this = this;

            // Show a spinner in the text box until we get results NOTE: STYLES ARE IN TEMPORARY
            jQuery(_this.textbox).addClass('comboLoading');

            // use search index for race conditions
            _this.searchIndex += 1;
            var _tmpIndex = _this.searchIndex;

            overrideBlockUI = true;
            var flag = sm.portal.vm.custom.callCustomization('RetainCustomAppearance');
            if (flag) {
                if (_this.textbox.val().trim() === '') {
                    // Remove the spinner from this textbox
                    jQuery(_this.textbox).removeClass('comboLoading');
                    return false;
                }
            }
            if (_this.textbox.val() && (_this.textbox.val().search('<') > -1 || _this.textbox.val().search('>') > -1)) {
                _this.textbox.val(_this.textbox.val().replace('<', '').replace('>', ''));
            }

            //var submitData = { data: _this.textbox.val() };
            _this.searchUrl = _this.element.attr('data-combobox-search');
            var url = '';
            if (_this.searchUrl && _this.searchUrl.includes('GetDocumentType')) {
                url = _this.baseUrl + _this.searchUrl + "&data=" + _this.textbox.val();
            } else {
                url = _this.baseUrl + _this.searchUrl + "?data=" + _this.textbox.val();
            }
            if (_this.searchUrl == 'externalCourseSeach' || _this.searchUrl == 'externalCourseSearchTitle') {
                // console.log(sm.portal.page.myTransferCredit);

                var externalCourseData = [];
                externalCourseData = sm.portal.page.myTransferCredit;
                if (externalCourseData.length == 0) {
                    _this.resultsDiv.css({ 'z-index': 99 }).show();
                    var resultList = jQuery("<ul id='collegeTable' class='listResults' />");
                    resultList.append("<li data-ignore='true'>No results</li>");
                    _this.resultsDiv.html(resultList);
                    jQuery(_this.textbox).removeClass('comboLoading');
                    return;
                }
                var filterCourses = [];
                if(_this.searchUrl == 'externalCourseSeach') {
                    var count = 0;
                    filterCourses = externalCourseData.filter(element => {
                        if (count < 10 && element.ExternalCourseId.toLowerCase().includes(_this.textbox.val().toLowerCase())) {
                            count++;
                            return true;
                        }
                    });
                } else {
                    var count = 0;
                    filterCourses = externalCourseData.filter(element => {
                        if (count < 10 && element.ExternalCourseTitle.toLowerCase().includes(_this.textbox.val().toLowerCase())) {
                            count++;
                            return true;
                        }
                    });
                }
                var isTextboxVisible = jQuery(_this.textbox).is(':visible');
                // make sure we're the current result & user still see combobox
                if (_tmpIndex == _this.searchIndex && isTextboxVisible) {

                    // always position in the correct spot
                    _this._positionResults();

                    // make the results div visible, and zindexed properly
                    _this.resultsDiv.css({ 'z-index': 99 }).show();

                    var resultList = jQuery("<ul id='collegeTable' class='listResults' />");
                    if (filterCourses.length > 0) {

                        // Loop through the Payload Result and construct the items
                        for (var i = 0; i < filterCourses.length; i++) {

                            var item = filterCourses[i];

                            // In-Result Highlighting

                            if(_this.searchUrl == 'externalCourseSeach') {
                                resultList.append("<li class='sponsorList' data-id-value='" + item.ExternalCourseId + "' data-display-value='" + item.ExternalCourseId + "' title='" + item.ExternalCourseId + "'>" + item.ExternalCourseId + "</li>");
                            } else {
                                resultList.append("<li class='sponsorList' data-id-value='" + item.ExternalCourseTitle + "' data-display-value='" + item.ExternalCourseTitle + "' title='" + item.ExternalCourseTitle + "'>" + item.ExternalCourseTitle + "</li>");
                            }
                            // Remove the spinner from this textbox
                            jQuery(_this.textbox).removeClass('comboLoading');
                        }
                    } else {
                        resultList.append("<li class='no-res-found' data-ignore='true'>No results.</li>");
                        // Remove the spinner from this textbox
                        jQuery(_this.textbox).removeClass('comboLoading');
                    }

                    _this.resultsDiv.html(resultList);

                    // add active hover event to items
                    _this.resultsDiv.find('li').each(function () {
                        var li = jQuery(this);

                        // wire up hover
                        li.unbind('hover').hover(function () {
                            li.parent().find('li').removeClass('active');
                            li.addClass('active');
                        }, function () {
                            li.parent().find('li').removeClass('active');
                        });

                        // wire up click event
                        li.unbind('mousedown').on('mousedown', function (event) {
                            _this._selectResult(jQuery(this));
                            event.preventDefault();
                        });
                    });
                }
            } else {
                jQuery.ajax({
                    url: url, // undo code due to US - 146046
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    //data: JSON.stringify(submitData),
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        var isTextboxVisible = jQuery(_this.textbox).is(':visible');

                        // make sure we're the current result & user still see combobox
                        if (_tmpIndex == _this.searchIndex && isTextboxVisible) {

                            // always position in the correct spot
                            _this._positionResults();

                            // make the results div visible, and zindexed properly
                            _this.resultsDiv.css({ 'z-index': 99 }).show();

                            container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                            var resultCount = data.ResultCount;
                            var searchTerm = data.SearchTerm;

                            var resultList = jQuery("<ul id='collegeTable' class='listResults' />");
                            if (container.Payload.length > 0) {

                                // Loop through the Payload Result and construct the items
                                for (var i = 0; i < container.Payload.length; i++) {

                                    var item = container.Payload[i];

                                    // In-Result Highlighting
                                    var highlightedTerm = "<span class='hilite'>" + searchTerm + "</span>";
                                    var re = new RegExp(searchTerm, 'g');
                                    var displayText = item.Text.replace(re, highlightedTerm);

                                    resultList.append("<li class='sponsorList' data-id-value='" + item.Value + "' data-display-value='" + item.Text.replace("'", '&#39') + "' title='" + item.Text.replace("'", '&#39') + "'>" + displayText + "</li>");
                                    // Remove the spinner from this textbox
                                    jQuery(_this.textbox).removeClass('comboLoading');
                                }


                            } else {
                                resultList.append("<li class='no-res-found' data-ignore='true'>No results.</li>");
                                // Remove the spinner from this textbox
                                jQuery(_this.textbox).removeClass('comboLoading');
                            }

                            _this.resultsDiv.html(resultList);

                            // add active hover event to items
                            _this.resultsDiv.find('li').each(function () {
                                var li = jQuery(this);

                                // wire up hover
                                li.unbind('hover').hover(function () {
                                    li.parent().find('li').removeClass('active');
                                    li.addClass('active');
                                }, function () {
                                    li.parent().find('li').removeClass('active');
                                });

                                // wire up click event
                                li.unbind('mousedown').on('mousedown', function (event) {
                                    _this._selectResult(jQuery(this));
                                    event.preventDefault();
                                });
                            });
                        }



                        jQuery('body').off('click.combobox').on('click.combobox', function () {
                            if (jQuery('.no-res-found').length) {
                                jQuery('#comboboxResults').hide();
                            }
                        })

                    },
                    error: function (e) {
                        //trs.ui.displayError(e.responseText);
                        _this.resultsDiv.css({ 'z-index': 99 }).show();
                        var resultList = jQuery("<ul id='collegeTable' class='listResults' />");
                        resultList.append("<li data-ignore='true'>No results</li>");
                        _this.resultsDiv.html(resultList);
                        jQuery(_this.textbox).removeClass('comboLoading');
                    }
                });
            }
        },

        // hide results div
        _hideResults: function () {
            this.resultsDiv.hide();
            this.resultsDiv.html('');
            this.flyoutDiv.hide();
            this.flyoutDiv.html(this.defaultInfoHtml);
        },

        // attempt to select an item from the results list
        _selectResult: function (item) {
            var _this = this;
            var value = _this.textbox.val();
            var lst = _this._getResults();
            var validResult = false;

            // mark dialog as dirty
            jQuery('#' + _this.element.parents('[data-editor-for]').attr('data-editor-for')).attr('data-form-dirty', 'true');

            // either use the passed in item, or grab the active item
            item = (item == null || item.length == 0) ? _this._getActive() : item;

            // if we still didn't have an item, but we only have a single search result, and we haven't modified the text in the input, then use it
            item = ((item == null || item.length == 0) && lst.length == 1) ? lst.first() : item;

            _this.textbox.val(item.attr('data-display-value')).trigger('change');

            // if we have a selection, use the value
            if (item != null && item.length > 0) {
                _this.hidden.val(item.attr('data-id-value')).trigger('change');     // RAB CHANGE
                _this.statusIcon.removeClass('resultsNotFound').addClass('resultsFound');
                validResult = true;
            }
            else {

                // check to see if the user even changed anything, if not, leave it all alone
                if (_this.startValue == _this.textbox.val() && parseInt(_this.hidden.val()) > 0) {
                    _this.statusIcon.removeClass('resultsNotFound').addClass('resultsFound');
                    validResult = true;
                }
                else {

                    // the user has entered a blank or incorrect value
                    _this.hidden.val(0).trigger('change');  // RAB CHANGE
                    _this.statusIcon.removeClass('resultsFound');

                    // if it is blank, then don't show the not found icon
                    if (!sm.portal.utility.isNullOrEmpty(value)) {
                        _this.statusIcon.addClass('resultsNotFound');
                    }
                    else {
                        _this.statusIcon.removeClass('resultsNotFound');
                    }
                }

            }

            // set up the flyout
            _this._setupFlyout(validResult);

            // hide he results div
            _this._hideResults();

            // reset start value
            _this.startValue = _this.textbox.val();

        },

        // configure flyout to open for newly selected value
        _setupFlyout: function (validResult) {
            var _this = this;

            // set up the flyout
            if (validResult) {

                // make sure it loads fresh the next time
                _this.loadFlyout = true;

                // wire up the click event to open the flyout
                _this.statusIcon.unbind('click').bind('click', function (event) {
                    var flyoutID = _this.flyoutDiv.attr('id');
                    var inputID = _this.flyoutDiv.find('#id');

                    // update the value for data round up, or insert it if it isn't there yet
                    if (inputID.length == 0) {
                        jQuery("<input type='hidden' name='id' id='id' value='" + _this.hidden.val() + "' data-binding='id' data-source='" + flyoutID + "' />").appendTo(_this.flyoutDiv);
                    }
                    else {
                        inputID.val(_this.hidden.val());
                    }

                    // update the url
                    _this.flyoutDiv.attr('data-content-url', _this.infoUrl);

                    // open the flyout, after opening, don't get fresh again until new value loaded
                    trs.ui.toggleContentFlyout(flyoutID, _this.statusIcon, _this.loadFlyout, true, function () { _this.loadFlyout = false; }, null, event);
                });
            }
            else {
                _this.statusIcon.unbind('click');
            }
        },

        // navigates the current active item in the results list
        _navigateResults: function (dir) {
            var lst = this._getResults();
            var act = this._getActive();

            // first, clear all active
            lst.removeClass('active');

            // now determine the next index
            if (lst.length > 0) {
                if (act.length == 0) {
                    if (dir == 1) {
                        lst.first().addClass('active');
                    }
                    else {
                        lst.last().addClass('active');
                    }
                }
                else {
                    var currentIndex = act.index();
                    var newIndex = currentIndex + dir;

                    // first/last wrap around code
                    if (newIndex < 0) {
                        lst.last().addClass('active');
                    }
                    else if (newIndex >= lst.length) {
                        lst.first().addClass('active');
                    }
                    else {
                        jQuery(lst[newIndex]).addClass('active');
                    }
                }
            }
        },

        // returns all items in the results list except "<li>No results found.</li>"
        _getResults: function () {
            return this.resultsDiv.find('li').not('[data-ignore]');
        },

        // puts the results div where it needs to be
        _positionResults: function () {
            var offset = this.textbox.offset();
            this.resultsDiv.css({ "top": offset.top + this.textbox.outerHeight(), "left": offset.left });
        },

        // find the active item in the list
        _getActive: function () {
            return this.resultsDiv.find('li.active');
        },

        // clean up
        _destroy: function () {
            this.resultsDiv.html('');
            this.flyoutDiv.html(this.defaultInfoHtml);
        },

        // allow option setting as per jquery widget
        _setOption: function (key, value) {
            switch (key) {
                case 'status':
                    switch (value) {
                        case 'valid':
                            this._setupFlyout(true);
                            this.statusIcon.removeClass('resultsNotFound').addClass('resultsFound');
                            break;
                        case 'invalid':
                            this.statusIcon.addClass('resultsNotFound').removeClass('resultsFound');
                            break;
                        case 'default':
                            this.statusIcon.removeClass('resultsNotFound').removeClass('resultsFound');
                            break;
                    }
                    break;
                default:
                    this._super(key, value);
                    break;
            }
        }

    });

}(jQuery));